var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 13.111,
    viewBox: "0 0 24 13.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path9413",
    d: "M1.4,299.875H20.535l-3.585,3.585a1.092,1.092,0,0,0,1.545,1.545l3.265-3.27,2.18-2.183a1.09,1.09,0,0,0,0-1.536l-5.445-5.452a1.092,1.092,0,1,0-1.545,1.545l3.594,3.585H1.341a1.091,1.091,0,1,0,.056,2.181Z",
    transform: "translate(-0.257 -292.234)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDeposit);
export default __webpack_public_path__ + "static/media/arrowRightDeposit.8dd404689c78d1fcbef4383cf55cc7f5.svg";
export { ForwardRef as ReactComponent };